'use client';

import { useEffect } from 'react';
import { toast } from 'sonner';

interface MessageToastProps {
  message?: string;
}

export function MessageToast({ message }: MessageToastProps) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        toast.warning(message);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [message]);

  return null;
}
